import { getProductListData } from '../products/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { ISelectItem, IEntitySelectItem, TEntityId } from '~/types/models'
import type {
  IProductGroup,
  IProductGroupOverview,
  TProduct,
} from '~/types/product/models'

const productGroupListData = undefined as unknown as IProductGroup[]

export const getProductGroupListData = getListDataFunctionFactory<
  IProductGroup[]
>({
  listData: productGroupListData,
  storageKey: 'productgroups',
  getStartingListData: getStartingProductGroupListData,
})

export function _getPRGDataById(
  id: TEntityId,
  list: IProductGroup[]
): IProductGroup {
  if (!list) {
    throw new Error(`_getPRGDataById called with undefined/null list`)
  }
  const productGroup = list.find((p: IProductGroup) => p.id === id)
  if (!productGroup) {
    throw new Error(`Can't find productGroup '${id}'`)
  }
  return productGroup
}

export async function getProductGroupDataById(
  id: string
): Promise<IProductGroup> {
  const list: IProductGroup[] = await getProductGroupListData()
  return _getPRGDataById(id, list)
}

export function _getPRGSelectItemDataById(
  id: TEntityId,
  list: IProductGroup[]
): IEntitySelectItem {
  if (!list) {
    throw new Error(`_getPRGSelectItemDataById called with undefined/null list`)
  }
  const productGroup = _getPRGDataById(id, list)
  return { id: productGroup.id, label: productGroup.descr }
}

export async function getProductGroupSelectDataById(
  id: string
): Promise<IEntitySelectItem> {
  const stg = await getProductGroupDataById(id)
  return { id: stg.id, label: stg.descr }
}

export async function getProductsData(
  id: string
): Promise<TProduct[] | undefined> {
  const list = await getProductListData()
  return list.filter((product: TProduct) => product.productGroup.id === id)
}

export async function getProductGroupOverviewData(
  id: string
): Promise<IProductGroupOverview | undefined> {
  const list = await getProductGroupListData()
  const productGroupData = list.find(
    (productGroup: IProductGroup) => productGroup.id === id
  )
  if (!productGroupData) {
    return undefined
  }
  const productsData = (await getProductsData(id)) || []
  const overviewData = {
    productGroup: productGroupData,
    products: productsData,
  }
  console.debug(overviewData)
  return overviewData
}

export async function getStartingProductGroupListData(): Promise<
  IProductGroup[]
> {
  return [
    {
      id: 'XXPRG0001',
      hrid: 'PRG0001',
      productSubcategory: { id: 'XXPRSC0006', label: 'General' },
      descr: 'Default',
      numItems: 0,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0002',
      hrid: 'PRG0002',
      productSubcategory: { id: 'XXPRSC0001', label: 'Internet Access' },
      descr: 'DIA',
      numItems: 4,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0003',
      hrid: 'PRG0003',
      productSubcategory: { id: 'XXPRSC0005', label: 'Professional Services' },
      descr: 'Consulting Services',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0004',
      hrid: 'PRG0004',
      productSubcategory: { id: 'XXPRSC0001', label: 'Internet Access' },
      descr: 'Other Network',
      numItems: 3,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0005',
      hrid: 'PRG0005',
      productSubcategory: { id: 'XXPRSC0003', label: 'Transport' },
      descr: 'Telco',
      numItems: 2,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0006',
      hrid: 'PRG0006',
      productSubcategory: { id: 'XXPRSC0004', label: 'Cloud Voice' },
      descr: 'UCaaS',
      numItems: 2,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0007',
      hrid: 'PRG0007',
      productSubcategory: { id: 'XXPRSC0004', label: 'Cloud Voice' },
      descr: 'VOIP',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0008',
      hrid: 'PRG0008',
      productSubcategory: { id: 'XXPRSC0002', label: 'WAN' },
      descr: 'E-LAN',
      numItems: 4,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0009',
      hrid: 'PRG0009',
      productSubcategory: { id: 'XXPRSC0002', label: 'WAN' },
      descr: 'SDWAN',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRG0010',
      hrid: 'PRG0010',
      productSubcategory: { id: 'XXPRSC0004', label: 'Cloud Voice' },
      descr: 'CCaaS',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
  ]
}
